<template>
  <v-btn v-if="buttonSize === ''" :height="buttonHeight" :width="buttonWidth" rounded="pill" outlined
    class="primary outline custom-button" @click="handleClick" flat>
    <v-icon v-if="iconType === 'icon' && iconPlacement === 'prepend'" left
      :class="['mdi', buttonIcon, 'primary-icon']"></v-icon>
    <img v-if="iconType === 'image'" :src="getImageSrc(index)" alt="" class="zetrix-mini" />
    &nbsp;
    <b class="primary-icon"> {{ buttonName }}</b>
    <v-icon v-if="iconType === 'icon' && iconPlacement === 'append'" left
      :class="['mdi', buttonIcon, 'primary-icon']"></v-icon>
  </v-btn>

  <v-btn v-else-if="buttonSize !== ''" :height="buttonHeight" :width="buttonWidth" rounded="pill" outlined
    class="primary outline custom-button" @click="handleClick" :size="buttonSize" flat>
    <v-icon v-if="iconType === 'icon' && iconPlacement === 'prepend'" left
      :class="['mdi', buttonIcon, 'primary-icon']"></v-icon>
    <img v-if="iconType === 'image'" :src="getImageSrc(index)" alt="" class="zetrix-mini" />
    &nbsp;
    <b class="primary-icon"> {{ buttonName }}</b>
    <v-icon v-if="iconType === 'icon' && iconPlacement === 'append'" left
      :class="['mdi', buttonIcon, 'primary-icon']"></v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "ButtonOutline",
  props: {
    index: {
      type: Number,
      default: null
    },
    buttonName: {
      type: String,
      default: "",
    },
    buttonSize: {
      type: String,
      default: "",
    },
    buttonHeight: {
      type: String,
      default: "50",
    },
    buttonWidth: {
      type: String,
      default: "180",
    },
    iconPlacement: {
      type: String,
      default: "",
    },
    iconType: {
      type: String,
      default: "",
    },
    buttonIcon: {
      type: String,
      default: "",
    },
    process: {
      type: Function,
      default: null,
    }, // Dynamic method
  },
  methods: {
    handleClick() {
      this.$emit("customProcess");
    },
    getImageSrc() {
      return require(`@/assets/images/Zetrix-flaticon-48x48.png`);
    },
  },
};
</script>

<style scoped></style>
